import $ from 'jquery';

class JobSourceFeed {
	constructor( node ) {
		this.node = node;
		this.page = 1;
		this.shown = parseInt(this.node.getAttribute('data-shown'), 10);

		this.$node      = $(node);
		this.$items     = this.$node.find('.shortcode__jobsource-feed__items');
		this.$itemsWrap = this.$node.find('.shortcode__jobsource-feed__items__wrap');
		this.$item      = this.$node.find('.shortcode__jobsource-feed__item');
		this.$footer    = this.$node.find('.shortcode__jobsource-feed__footer');

		this.pages = Math.ceil(this.$item.length / this.shown);

		this.$linkUp = this.$footer.find('.shortcode__jobsource-feed__footer__up');
		this.$linkUp.on('click', this.up.bind(this));

		this.$linkDown = this.$footer.find('.shortcode__jobsource-feed__footer__down');
		this.$linkDown.on('click', this.down.bind(this));

		this.calcHeight();
		this.$items.scrollTop(0);
	}

	up(e) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}

		if (this.page > 1) {
			this.page--;
			this.scroll();
		}

	}

	down(e) {
		if (e && e.preventDefault) {
			e.preventDefault();
		}

		if ( this.page < this.pages ) {
			this.page++;
			this.scroll();
		}
	}

	scroll() {
		let scrollTop = 0;
		this.$item.slice(0, (this.page - 1) * this.shown).each((index, item) => {
			scrollTop += $(item).outerHeight();
		});

		this.$items.animate({
			scrollTop: Math.round(scrollTop)
		}, 400);

		this.calcHeight();
	}

	calcHeight() {
		let height = 0;

		this.$item.slice((this.page - 1) * this.shown, ((this.page) * this.shown)).each((index, item) => {
			height += $(item).outerHeight();
		});

		this.$itemsWrap.css('height', Math.round(height));
	}
}

export default JobSourceFeed;
